module.exports = __webpack_public_path__ + "static/media/cliente.4874eda7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/modelo/cliente.svg
// module id = 192
// module chunks = 0